import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

type Props = {
  color: string;
  id: string;
};

const pinStyle = {
	cursor: "pointer",
	stroke: "none",
};

const Pin = ({ color, id }: Props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const onClick = (e) => {
		dispatch({ type: 'SET_StationId', payload: id });
		// navigate(`/stations/${id}`)
	};
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			style={{
				...pinStyle,
			}}
			onClick={(e) => onClick(e)}
		>
			<rect
				id="backgroundrect"
				width="100%"
				height="100%"
				x="0"
				y="0"
				fill="none"
				stroke="none"
			/>

			<g>
				<circle
					cx="11.999999284744263"
					cy="11.999999761581421"
					r="12"
					fill={color}
					id={id}
				/>
				<path
					d="M18.512430801391602,7.737567052841186 L18.519930801391602,7.730067052841186 L15.729930801391603,4.9400670528411865 L14.934930801391602,5.735067052841188 L16.5174308013916,7.317567052841188 C15.812430801391603,7.587567052841187 15.309930801391602,8.262567052841188 15.309930801391602,9.065067052841187 C15.309930801391602,10.100067052841187 16.1499308013916,10.940067052841187 17.1849308013916,10.940067052841187 C17.4549308013916,10.940067052841187 17.7024308013916,10.880067052841188 17.9349308013916,10.782567052841188 V16.190067052841187 C17.9349308013916,16.602567052841188 17.597430801391603,16.940067052841187 17.1849308013916,16.940067052841187 C16.7724308013916,16.940067052841187 16.4349308013916,16.602567052841188 16.4349308013916,16.190067052841187 V12.815067052841187 C16.4349308013916,11.990067052841187 15.7599308013916,11.315067052841187 14.934930801391602,11.315067052841187 H14.184930801391602 V6.0650670528411865 C14.184930801391602,5.240067052841187 13.5099308013916,4.5650670528411865 12.684930801391602,4.5650670528411865 H8.184930801391602 C7.359930801391602,4.5650670528411865 6.684930801391602,5.240067052841187 6.684930801391602,6.0650670528411865 V18.065067052841187 H14.184930801391602 V12.440067052841187 H15.309930801391602 V16.190067052841187 C15.309930801391602,17.225067052841187 16.1499308013916,18.065067052841187 17.1849308013916,18.065067052841187 C18.2199308013916,18.065067052841187 19.0599308013916,17.225067052841187 19.0599308013916,16.190067052841187 V9.065067052841187 C19.0599308013916,8.547567052841188 18.8499308013916,8.075067052841188 18.512430801391602,7.737567052841186 zM17.1849308013916,9.815067052841187 C16.7724308013916,9.815067052841187 16.4349308013916,9.477567052841188 16.4349308013916,9.065067052841187 C16.4349308013916,8.652567052841185 16.7724308013916,8.315067052841187 17.1849308013916,8.315067052841187 C17.597430801391603,8.315067052841187 17.9349308013916,8.652567052841185 17.9349308013916,9.065067052841187 C17.9349308013916,9.477567052841188 17.597430801391603,9.815067052841187 17.1849308013916,9.815067052841187 zM9.684930801391602,15.815067052841187 V12.440067052841187 H8.184930801391602 L11.184930801391602,6.8150670528411865 V10.565067052841187 H12.684930801391602 L9.684930801391602,15.815067052841187 z"
					fill="white"
				/>
			</g>
		</svg>
	);
};

export default Pin;
